import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getBatches,
  deleteBatch, getActiveBatches,getBatchReport
} from "../../actions/batchActions";

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import "react-datepicker/dist/react-datepicker.css";
import "react-table/react-table.css";
import "react-report-builder/lib/main.css";

class BatchList extends Component {
  constructor() {
    super();
    this.state = {
      selectedFile: undefined,
      batchDate: "",
      progress: 0,
      errors: {},
    };
    this.addBatch = this.addBatch.bind(this);
    this.editBatch = this.editBatch.bind(this);
    this.deleteBatch = this.deleteBatch.bind(this);
    this.viewBatch = this.viewBatch.bind(this);
    this.getBatchReport = this.getBatchReport.bind(this);
    
    this.getActiveBatches = this.getActiveBatches.bind(this);
  }

  componentDidMount() {
    this.props.getBatches();
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  addBatch() {
    this.props.history.push("/add-batch");
  }
  editBatch(batchId) {
    this.props.history.push(`/edit-batch/${batchId}`);
  }

  deleteBatch(batchId) {
    this.props.deleteBatch(batchId);
  }

  viewBatch(batchId) {
    this.props.history.push(`/view-batch/${batchId}`);
  }

  getActiveBatches() {
    this.props.getActiveBatches(this.state.batchDate);
  }

  
  getBatchReport(batchId) {
    this.props.getBatchReport(batchId);
  }


  render() {
    const { batches } = this.props.batch;
    const header = (
      <div style={{ textAlign: "left" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={(e) => this.setState({ globalFilter: e.target.value })}
          placeholder="Global Search"
          size="50"
        />

        <button
          className="btn btn-success  float-right"
          onClick={() => this.addBatch()}
        >
          New Batch
        </button>
      </div>
    );

    const paginatorLeft = <Button icon="pi pi-refresh" />;


    const actionTemplate = (rowData, column) => {
      return (
        <div>
         <Button
            type="button"
            icon="pi pi-print"
            className="p-button-primary"
            tooltip="Print List"
            onClick={() => this.getBatchReport(rowData.id)}
            style={{ marginRight: ".2em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-search"
            className="p-button-success"
            tooltip="View batch"
            onClick={() => this.viewBatch(rowData.id)}
            style={{ marginRight: ".2em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-warning"
            tooltip="Edit batch"
            onClick={() => this.editBatch(rowData.id)}
            style={{ marginRight: ".3em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-times"
            className="p-button-danger"
            tooltip="Delete batch"
            onClick={() => this.deleteBatch(rowData.id)}
          ></Button>
        </div>
      );
    };

    return (
      <div>
        <div className="container-fluid mt-5">
          <div className="col-sm-4">
            <label>Choose Month</label>
            <input
              type="date"
              required
              className="form-control "
              name="batchDate"
              onChange={this.onChange}
              value={this.state.batchDate || ""}
            />
          
          </div>
          <div className="col-sm-4">
            <button
              className="btn btn-success  "
              onClick={() => this.getActiveBatches()}
            >
              Active Members
            </button>
            </div>


          <div className="card m-auto  shadow-lg rounded p-3">
            <h1 className="m-auto text-center display-4">
              Receipt Batch List
            </h1>

            <div className="card">
              <DataTable
                value={batches}
                paginator={true}
                paginatorLeft={paginatorLeft}
                header={header}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                rows={50}
                rowsPerPageOptions={[50, 100, 500]}
                globalFilter={this.state.globalFilter}
                emptyMessage="No records found"
              >
                <Column
                  field="institution.institutionName"
                  header="Institution"
                />
                <Column field="batchDate" header="Batch Date" />
                <Column field="cycleNumber" header="Cycle" />
                <Column field="totalAmount" header="Amount" />
                <Column field="male" header="Males" />
                <Column field="female" header="Females" />
                <Column field="receiptNumber" header="Receipt Number" />
                <Column field="currency" header="Currency" />
                <Column field="rate.rate" header="Rate" />
                <Column
                  body={actionTemplate.bind(this)}
                  header="Actions"
                  style={{ textAlign: "center" }}
                />

              </DataTable>
            </div>
          </div>
        </div>
      </div>


    );
  }
}
BatchList.propTypes = {

  getBatches: PropTypes.func.isRequired,
  deleteBatch: PropTypes.func.isRequired,
  getActiveBatches: PropTypes.func.isRequired,

  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  batch: state.batch,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getBatches,
  deleteBatch,
  getActiveBatches,
  getBatchReport

})(BatchList);
